import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';

import PaymentContext from '../PaymentContext';

const PromoContainer = ({ hasSpecialMcPromo = false }) => {
  const { promoCode, setPromoCode, checkoutData, isPromoLoading, setIsPromoLoading } = useContext(PaymentContext);
  const { discount } = checkoutData || {};
  const [isUsingPromoCode, setIsUsingPromoCode] = useState(false);
  const [promoInput, setPromoInput] = useState('');

  const applyPromoCode = () => {
    if (promoCode !== promoInput) {
      setPromoCode(promoInput);
      setIsPromoLoading(true);
    }
  };

  useEffect(() => {
    if (discount) {
      setIsUsingPromoCode(false);
    }
  }, [discount]);

  if (isUsingPromoCode && !hasSpecialMcPromo) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignSelf: 'start',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 2,
          m: '5px 0px',
        }}
      >
        <TextField
          label="Promo Code"
          size="small"
          variant="outlined"
          value={promoInput}
          onChange={(e) => setPromoInput(e.target.value)}
        />
        {promoInput && (
          <Button variant="contained" onClick={applyPromoCode} size="small" disabled={isPromoLoading}>
            {isPromoLoading ? 'Loading...' : 'Apply'}
          </Button>
        )}
        {discount === 0 && promoCode && !isPromoLoading && (
          <Typography variant="caption" color="darkred">
            Invalid Promo Code
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'start',
        gap: 0.5,
      }}
    >
      <Button
        variant="text"
        sx={{ textTransform: 'none', p: 0 }}
        onClick={() => setIsUsingPromoCode(true)}
        disabled={hasSpecialMcPromo}
      >
        Use Promo Code
      </Button>
      {hasSpecialMcPromo && (
        <Typography variant="caption" sx={{ fontStyle: 'italic', color: 'error.main' }}>
          Promo codes cannot be used in conjunction with this offer
        </Typography>
      )}
    </Box>
  );
};

export default PromoContainer;
